<template>
    <b-modal
        v-model="showModal"
        hide-footer
        dialog-class="modal-dialog-centered"
        class="v-modal-custom"
        title=""
        centered
        size="fullscreen"
    >
      <div class="modal-body" style="background: #F3F6F9;">
        xxxxxx
      </div>
    </b-modal>
</template>

<script>
export default {
    data () {
        return {
            showModal: false,
        }
    },
    methods:{
        open() {
            this.showModal = true
        },
    }
}
</script>

<style lang="scss" scoped>

</style>